import type { MessageDictionary } from '../types';

export const enMessages: MessageDictionary = {
  'i18n.languageSwitcher.label': 'Language',
  'i18n.languageSwitcher.english': 'English',
  'i18n.languageSwitcher.simplifiedChinese': 'Simplified Chinese',
  'i18n.languageSwitcher.traditionalChinese': 'Traditional Chinese',
  'i18n.fallbackProbe': 'English fallback probe',
  'nav.home': 'Home',
  'nav.allTutors': 'All Tutors',
  'nav.allCases': 'All Cases',
  'nav.becomeTutor': 'Become a Tutor',
  'nav.aboutUs': 'About Us',
  'nav.support': 'Support',
  'nav.howItWorks': 'How It Works',
  'nav.helpCenter': 'Help Center',
  'nav.tuitionFeeReference': 'Tuition Fee Reference',
  'nav.findTutor': 'Find your tutor',
  'nav.registerTutor': 'Register as tutor',
  'nav.login': 'Login',
  'nav.myCases': 'My Cases',
  'nav.myLikedTutors': 'My Liked Tutors',
  'nav.editProfile': 'Edit Profile',
  'nav.completeProfile': 'Complete Profile',
  'nav.uploadDocuments': 'Upload Documents',
  'nav.myApplications': 'My Applications',
  'nav.logout': 'Logout',
  'nav.userFallback': 'User',
  'nav.pendingVerification': 'Pending verification',
  'nav.verified': 'Verified',
  'nav.approved': 'Approved',
  'nav.rejected': 'Rejected',
  'nav.musicPromo.mobile': 'Music tutors coming soon',
  'nav.musicPromo.desktop':
    'Music Tutor coming soon. Join the waitlist for first updates and early access.',
  'nav.musicPromo.join': 'Join',
  'nav.musicPromo.joinWaitlist': 'Join the waitlist',
  'nav.musicPromo.dismiss': 'Dismiss music waitlist promotion',
  'footer.tagline': 'Connecting passionate tutors with eager learners across Malaysia.',
  'footer.quickLinks': 'Quick Links',
  'footer.findTutors': 'Find Tutors',
  'footer.company': 'Company',
  'footer.termsCustomers': 'Terms - Customers',
  'footer.termsTutors': 'Terms - Tutors',
  'footer.privacyPolicy': 'Privacy Policy',
  'footer.contactUs': 'Contact Us',
  'footer.location': 'Kuala Lumpur, Malaysia',
  'footer.copyright':
    '© 2026 Glowston Tech (Business Registration No. 202503300880). All rights reserved.',
  'notFound.description': 'The page you are looking for does not exist.',
  'whatsapp.defaultMessage': 'Hello! I would like to know more about Tutor Founder.',
  'whatsapp.ariaLabel': 'Contact us on WhatsApp',
  'whatsapp.title': 'Chat with us on WhatsApp',
  'aiMatch.title': 'AI Matching',
  'aiMatch.subtitle': 'Please select your role to continue',
  'aiMatch.tutor.title': "I'm a Tutor",
  'aiMatch.tutor.description': 'Register to offer tutoring services',
  'aiMatch.parent.title': "I'm a Parent/Student",
  'aiMatch.parent.description': 'Post a case to find tutors',
  'howItWorks.hero.title': 'How It Works',
  'howItWorks.hero.description':
    "Whether you're a parent looking for quality tutoring or a tutor growing your income, we've made the process clear, fair, and fast.",
  'howItWorks.tab.parents': 'For Parents',
  'howItWorks.tab.tutors': 'For Tutors',
  'howItWorks.journey.eyebrow': 'The journey',
  'howItWorks.journey.parent.title': 'From first click to first lesson',
  'howItWorks.journey.parent.description':
    'Five simple steps. No surprises, no paperwork — just great tutoring.',
  'howItWorks.journey.tutor.title': 'From sign-up to payday',
  'howItWorks.journey.tutor.description':
    'Five clear steps to becoming a verified, paid Tutor Founder tutor.',
  'howItWorks.cta.tutor.title': 'Ready to Start Teaching?',
  'howItWorks.cta.tutor.description':
    'Join our community of verified tutors and turn your teaching into a sustainable income.',
  'howItWorks.cta.tutor.button': 'Start Your Registration',
  'howItWorks.cta.parent.title': 'Ready to Find Your Tutor?',
  'howItWorks.cta.parent.description':
    'Use our AI Matching system to find the perfect tutor in seconds.',
  'howItWorks.cta.parent.button': 'Post Your First Case',
  'processFlow.parent.step1.tag': 'Tell us',
  'processFlow.parent.step1.title': 'Post your case',
  'processFlow.parent.step1.description':
    'Subject, level, location, and schedule. A short form — no sign-up required to start browsing.',
  'processFlow.parent.step1.meta': 'Takes about 2 minutes',
  'processFlow.parent.step2.tag': 'We match',
  'processFlow.parent.step2.title': 'Get qualified matches',
  'processFlow.parent.step2.description':
    'Our team shortlists 2-3 verified tutors who fit your subject, location, schedule, and budget. No cold calls, no guessing.',
  'processFlow.parent.step2.meta': 'Within 24 hours',
  'processFlow.parent.step3.tag': 'You choose',
  'processFlow.parent.step3.title': 'Review & pick your tutor',
  'processFlow.parent.step3.description':
    'Browse tutor profiles, qualifications, ratings, and experience. Choose the one that feels right — no pressure.',
  'processFlow.parent.step3.meta': 'Your decision, always',
  'processFlow.parent.step4.tag': 'Secure payment',
  'processFlow.parent.step4.title': 'Pay safely, 1 month upfront',
  'processFlow.parent.step4.description':
    "Your payment is held in secure escrow — it's only released to the tutor after lessons are delivered. Bank Transfer or TNG accepted.",
  'processFlow.parent.step4.meta': 'Funds held in escrow',
  'processFlow.parent.step5.tag': 'Begin learning',
  'processFlow.parent.step5.title': 'Start your first lesson',
  'processFlow.parent.step5.description':
    'Weekly lessons begin. Communicate directly with your tutor. Not satisfied? Switch tutors or get a refund for unused lessons.',
  'processFlow.parent.step5.meta': 'Free to switch anytime',
  'processFlow.tutor.step1.tag': 'Sign up',
  'processFlow.tutor.step1.title': 'Create your profile',
  'processFlow.tutor.step1.description':
    'Add your subjects, teaching levels, location, and rates. Set your schedule and teaching mode (online, in-person, or both).',
  'processFlow.tutor.step1.meta': 'Takes about 5 minutes',
  'processFlow.tutor.step2.tag': 'Verification',
  'processFlow.tutor.step2.title': 'Get verified',
  'processFlow.tutor.step2.description':
    'Submit a support document or certificate for review. Add your IC to qualify for the Verified badge after approval.',
  'processFlow.tutor.step2.meta': '2-3 business days',
  'processFlow.tutor.step3.tag': 'Matched',
  'processFlow.tutor.step3.title': 'Receive a case',
  'processFlow.tutor.step3.description':
    "When a parent posts a case matching your profile, you're notified by email and WhatsApp. Accept or decline — no obligation.",
  'processFlow.tutor.step3.meta': 'Via email & WhatsApp',
  'processFlow.tutor.step4.tag': 'Teach',
  'processFlow.tutor.step4.title': 'Conduct weekly lessons',
  'processFlow.tutor.step4.description':
    'You set the schedule and rate. Teach in-person or online — you and the parent coordinate directly. No platform middleman in your classroom.',
  'processFlow.tutor.step4.meta': 'Online or in-person',
  'processFlow.tutor.step5.tag': 'Get paid',
  'processFlow.tutor.step5.title': 'Monthly payout to your bank',
  'processFlow.tutor.step5.description':
    'Automatic transfer every month-end. Months 1-2: you receive 75%. Month 3+: 100%. The commission resets per new case, not per tutor.',
  'processFlow.tutor.step5.meta': 'Every month-end, automatic',
  'processFlow.svg.parent.case': 'Post a Case',
  'processFlow.svg.parent.subject': 'Subject',
  'processFlow.svg.parent.location': 'Location',
  'processFlow.svg.parent.submit': 'Submit ->',
  'processFlow.svg.parent.matches': '2 Matched Tutors',
  'processFlow.svg.parent.name': 'Wei Ling Tan',
  'processFlow.svg.parent.profile': 'BSc Math · Universiti Malaya',
  'processFlow.svg.parent.rating': '4.9 · 127 lessons',
  'processFlow.svg.parent.subject.math': 'Math',
  'processFlow.svg.parent.subject.addMath': 'Add Math',
  'processFlow.svg.parent.choose': 'Choose ->',
  'processFlow.svg.parent.bankTransfer': 'Bank Transfer',
  'processFlow.svg.parent.tng': 'TNG',
  'processFlow.svg.tutor.subject.math': 'Math',
  'processFlow.svg.tutor.subject.physics': 'Physics',
  'processFlow.svg.tutor.rate': 'RM 80/hr',
  'processFlow.svg.tutor.identityDocument': 'Identity Document',
  'processFlow.svg.tutor.accept': 'Accept',
  'processFlow.svg.tutor.pass': 'Pass',
  'processFlow.svg.tutor.equation': 'f(x) = 2x² + 3x',
  'processFlow.svg.tutor.monthlyPayout': 'Monthly Payout',
  'processFlow.svg.tutor.net': 'Net (Month 3+, one case)',
  'helpCenter.hero.title': 'Help Center',
  'helpCenter.hero.description': 'Find answers to your questions and get the support you need',
  'helpCenter.tab.common': 'Common Questions',
  'helpCenter.tab.tutor': 'For Tutors',
  'helpCenter.tab.parent': 'For Parents/Students',
  'helpCenter.section.common': 'Frequently Asked Questions',
  'helpCenter.section.tutor': 'Questions for Tutors',
  'helpCenter.section.parent': 'Questions for Parents & Students',
  'helpCenter.contact.title': 'Still Need Help?',
  'helpCenter.contact.description':
    "Can't find the answer you're looking for? Our support team is here to help!",
  'helpCenter.contact.email': 'Email Support',
  'helpCenter.contact.whatsapp': 'WhatsApp Us',
  'helpCenter.common.1.question': 'How do I create an account?',
  'helpCenter.common.1.answer':
    'You can create an account by clicking the "Login/Sign Up" button in the navigation bar. You can register using your email, phone number, or social media accounts (Google).',
  'helpCenter.common.2.question': 'Is Tutor Founder free to use?',
  'helpCenter.common.2.answer':
    'Yes, creating an account and browsing tutors or classes is completely free. We do not charge any platform fees for students or parents. Tutors can also register and list their services for free.',
  'helpCenter.common.3.question': 'How does payment work?',
  'helpCenter.common.3.answer':
    'Parents/students pay fees to the Tutor Founder platform when they book lessons. Tutor Founder securely holds those payments and issues payouts to tutors at the end of each month. This approach simplifies payments for parents and provides tutors with a reliable monthly payout schedule. Please refer to our Terms of Service & Payments page for fee details, payout windows, and dispute resolution steps.',
  'helpCenter.common.4.question': 'Is the platform safe and secure?',
  'helpCenter.common.4.answer':
    'Yes. Tutor Founder uses industry-standard security practices to protect your data and payments. We encrypt sensitive information, limit access to personal data, and work with trusted payment processors. For full details, see our Privacy & Security policy.',
  'helpCenter.common.5.question': 'What if a tutor stops teaching?',
  'helpCenter.common.5.answer':
    'If a tutor stops teaching or cannot continue, Tutor Founder will assist affected parents. We may offer refunds for unused prepaid lessons or help find a replacement tutor, depending on the situation. Refunds and dispute resolution follow our Refunds & Disputes policy — contact support for help.',
  'helpCenter.common.6.question': 'Can I cancel or reschedule lessons?',
  'helpCenter.common.6.answer':
    'Yes, you can cancel or reschedule lessons by communicating directly with your tutor. We encourage establishing clear cancellation policies at the start of your tutoring arrangement.',
  'helpCenter.common.7.question': 'What areas does Tutor Founder cover?',
  'helpCenter.common.7.answer':
    'Tutor Founder covers all major cities and states across Malaysia. We have tutors available for both physical and online tuition, expanding access to quality education nationwide.',
  'helpCenter.tutor.1.question': 'How do I become a verified tutor?',
  'helpCenter.tutor.1.answer':
    'To become verified, complete the tutor registration process and upload your identification documents (IC, passport, or driving license). Our team will review your application and verify your credentials within 2-3 business days.',
  'helpCenter.tutor.2.question': 'What qualifications do I need to be a tutor?',
  'helpCenter.tutor.2.answer':
    'While we welcome tutors with various qualification levels, we recommend having at least SPM or equivalent. Higher qualifications such as STPM, Diploma, or Degree certifications are highly valued. Teaching experience and subject expertise are also important factors.',
  'helpCenter.tutor.3.question': 'How do I set my tutoring rates?',
  'helpCenter.tutor.3.answer':
    'You can set your own hourly rates based on your qualifications, experience, and the subjects you teach. We provide a fee reference guide to help you price competitively. You can adjust your rates at any time from your profile settings.',
  'helpCenter.tutor.4.question': 'How will I receive case notifications?',
  'helpCenter.tutor.4.answer':
    "Once registered and verified, you'll receive notifications via email and WhatsApp when new classes matching your profile become available. You can customize your notification preferences in your account settings.",
  'helpCenter.tutor.5.question': 'Can I teach both online and physical classes?',
  'helpCenter.tutor.5.answer':
    'Yes! You can specify your preferred teaching modes (physical, online, or both) in your profile. This gives you flexibility and access to more potential students.',
  'helpCenter.tutor.6.question': "What should I do if there's an issue with a student?",
  'helpCenter.tutor.6.answer':
    'If you encounter any issues, we encourage open communication with the student or parent first. If problems persist, contact our support team through the Help Center or email us at tutorfounder@gmail.com.',
  'helpCenter.parent.1.question': 'How do I find a suitable tutor for my child?',
  'helpCenter.parent.1.answer':
    "You can browse our tutor listings using filters for subject, location, experience, and price. Alternatively, use our AI Matching system by posting a case with your requirements, and we'll match you with suitable tutors.",
  'helpCenter.parent.2.question': 'Are all tutors background-checked?',
  'helpCenter.parent.2.answer':
    'All tutors with the "Verified" badge have submitted identification documents which we have verified. However, we recommend conducting your own interview and checking references before committing to lessons.',
  'helpCenter.parent.3.question': "What if I'm not satisfied with a tutor?",
  'helpCenter.parent.3.answer':
    "If you're not satisfied with your tutor, you can search for and switch to a different tutor at any time. There are no contracts or commitments. We recommend giving feedback to help improve the platform.",
  'helpCenter.parent.4.question': 'How do I post a tuition case?',
  'helpCenter.parent.4.answer':
    'Click "AI Matching" in the navigation bar, select "I\'m a Parent/Student", and fill out the form with details about your tutoring needs including subject, level, location, and schedule preferences. Once submitted, suitable tutors will be notified.',
  'helpCenter.parent.5.question': 'Can I hire multiple tutors for different subjects?',
  'helpCenter.parent.5.answer':
    'Absolutely! You can post multiple classes for different subjects and engage with multiple tutors simultaneously. Each class is treated independently.',
  'earnings.badge.mostCommon': 'Most Common',
  'earnings.label.hoursPerWeek': 'Hours per week',
  'earnings.label.hourlyRate': 'Hourly Rate',
  'earnings.label.grossMonthly': 'Gross Monthly',
  'earnings.label.yourNet': 'Your Net',
  'earnings.footnote.label': 'Remember:',
  'earnings.footnote.text':
    'After month 2, your fee drops to 0%. You keep 100% of your gross monthly earnings.',
  'earnings.scenario.jason.description': 'Form 5 Mathematics',
  'earnings.scenario.sarah.description': 'Primary School English',
  'earnings.scenario.ahmad.description': 'A-Level Physics',
  'howItWorksFaq.tutor.1.question': 'How do I set my hourly rate?',
  'howItWorksFaq.tutor.1.answer':
    "You set your own rates based on your qualifications, experience, and subjects. We provide a tuition fee reference guide to help you price competitively. You can adjust rates anytime from your profile settings. There's no platform fee deduction on your rate—you negotiate directly with parents.",
  'howItWorksFaq.tutor.2.question': 'When exactly do I get paid?',
  'howItWorksFaq.tutor.2.answer':
    'We collect payments from parents upfront (for 1 month of lessons). You receive your share every month-end via automatic transfer to your registered bank account. Months 1-2 of a case: you get 75% (we take 25% commission). Month 3+: you get 100%. Transfers typically appear within 2-3 business days.',
  'howItWorksFaq.tutor.3.question': 'What is the 25% commission in the first 2 months?',
  'howItWorksFaq.tutor.3.answer':
    'Our platform commission applies only to the first 2 months per case to help cover our matching, verification, and escrow services. From month 3 onwards, that case is commission-free, and you keep 100% of your earnings. The commission structure resets per case independently—so if you take on a new case later, the first 2 months of that case also have the 25% commission.',
  'howItWorksFaq.tutor.4.question': 'What happens if a parent cancels?',
  'howItWorksFaq.tutor.4.answer':
    'If a parent cancels before lessons start or early, you may receive a partial payout depending on how much of the month has elapsed. If you cancel a lesson, inform the parent directly and handle rescheduling. Excessive cancellations may affect your profile rating. See our full Cancellation Policy in Terms & Conditions.',
  'howItWorksFaq.tutor.5.question': 'How do I get matched with parents?',
  'howItWorksFaq.tutor.5.answer':
    'After verification, you automatically appear in our tutor directory and AI matching system. When a parent posts a case matching your profile (subject, location, availability, rate), we notify you via email & WhatsApp. You can accept or decline—no obligation. More cases = more income potential.',
  'howItWorksFaq.tutor.6.question': 'Can I teach both online and in-person?',
  'howItWorksFaq.tutor.6.answer':
    'Absolutely! In your profile settings, specify your preferred teaching modes (online, in-person, or both). You can even teach the same subject in both formats to different parents. Flexibility helps you attract more cases.',
  'howItWorksFaq.tutor.7.question': "What if there's a payment dispute?",
  'howItWorksFaq.tutor.7.answer':
    'You have 7 days after the month-end payout date to raise a dispute if something seems wrong (e.g., incorrect calculation, missing payment). Contact our support team with details. We investigate and resolve within 7 business days. Our escrow system protects both you and the parent.',
  'howItWorksFaq.tutor.8.question': 'Can I teach multiple cases simultaneously?',
  'howItWorksFaq.tutor.8.answer':
    'Yes! Many tutors take on multiple cases with different parents. Each case is independent. For example, you could teach Math to one family and English to another. Earnings compound—more cases = higher monthly income. Just ensure you can manage your schedule.',
  'howItWorksFaq.parent.1.question': 'How much does it cost to find a tutor?',
  'howItWorksFaq.parent.1.answer':
    'Browsing tutors and posting a case is completely free. You only pay when you book lessons with a tutor you choose. Prices vary by tutor expertise and subject. Check our tuition fee reference guide for typical rates by education level.',
  'howItWorksFaq.parent.2.question': 'How do I post a case?',
  'howItWorksFaq.parent.2.answer':
    'Click "AI Matching" in the navigation, select "I\'m a Parent/Student", and fill out your details: subject, level, location, preferred schedule, and budget. Takes ~2 minutes. Once submitted, our AI matches you with 2-3 qualified tutors within 24 hours.',
  'howItWorksFaq.parent.3.question': 'What happens with my payment after I book?',
  'howItWorksFaq.parent.3.answer':
    'Your payment is held in escrow (secure account) until lessons complete. You pay 1 month upfront. At month-end, funds are transferred to your tutor. If you cancel or dispute, you can request a refund for unused lessons within our policy window.',
  'howItWorksFaq.parent.4.question': 'Can I get a refund if the tutor is not a good fit?',
  'howItWorksFaq.parent.4.answer':
    'Yes! If after the first lesson you\'re unsatisfied, you can request a refund for unused lessons. No contract lock-in. We encourage giving feedback—if issues persist, our support team can help facilitate a switch to another tutor or process a full refund.',
  'howItWorksFaq.parent.5.question': 'What payment methods do you accept?',
  'howItWorksFaq.parent.5.answer':
    'We accept Bank Transfer and Touch n Go (TNG) for Malaysian parents. Simply choose your preferred method during booking. Payments are encrypted and secure. We use trusted payment processors to protect your financial information.',
  'howItWorksFaq.parent.6.question': 'Are all tutors verified?',
  'howItWorksFaq.parent.6.answer':
    "Tutors with a 'Verified' badge have submitted ID documents which we have validated. However, we recommend conducting your own interview and checking references before committing. Our verification confirms identity—it's not a skills guarantee.",
  'howItWorksFaq.parent.7.question': 'Can I hire multiple tutors for different subjects?',
  'howItWorksFaq.parent.7.answer':
    'Absolutely! You can post multiple cases for different subjects and hire different tutors. Each case is independent—you pay per case, manage schedules separately, and can adjust or cancel one without affecting others.',
  'howItWorksFaq.parent.8.question': 'What if the tutor cancels lessons?',
  'howItWorksFaq.parent.8.answer':
    'If a tutor discontinues without warning, contact us immediately. We will help find a replacement tutor or process a refund for unused lessons. Your payment is protected—you will not lose money due to tutor cancellation.',
  'howItWorksFaq.parent.9.question': 'How do I communicate with my tutor?',
  'howItWorksFaq.parent.9.answer':
    "Once you book, you can message the tutor directly via our platform or exchange contact details (WhatsApp, email, phone). Schedule lessons, discuss topics, and coordinate directly. We stay out of day-to-day communication—it's between you and your tutor.",
  'howItWorksFaq.contact.description': "Can't find your answer? Check out our full",
  'howItWorksFaq.contact.helpCenter': 'Help Center',
  'howItWorksFaq.contact.suffix': 'or contact our support team.',
  'howItWorksFaq.contact.email': 'Email: tutorfounder@gmail.com',
  'paymentTimeline.tutor.title': 'Payment Flow for Tutors',
  'paymentTimeline.parent.title': 'Payment Flow for Parents',
  'paymentTimeline.tutor.protection.title': 'Your Payment is Protected',
  'paymentTimeline.tutor.protection.1': 'Parents pay upfront — your income is guaranteed.',
  'paymentTimeline.tutor.protection.2': 'Funds held in escrow until month-end for security.',
  'paymentTimeline.tutor.protection.3': 'Automatic transfer every month, no manual requests needed.',
  'paymentTimeline.tutor.protection.4': '7-day dispute window if payment issues arise.',
  'paymentTimeline.parent.refund.title': 'Easy Refunds',
  'paymentTimeline.parent.refund.1': 'Cancel anytime with refund for unused lessons.',
  'paymentTimeline.parent.refund.2': 'No lock-in contracts or hidden fees.',
  'paymentTimeline.parent.refund.3': 'If tutor discontinues, we help find replacement or refund.',
  'paymentTimeline.parent.protection.title': 'Your Protection',
  'paymentTimeline.parent.protection.1': 'All tutors verified with ID checks.',
  'paymentTimeline.parent.protection.2': '7-day dispute window if issues arise.',
  'paymentTimeline.parent.protection.3': "Funds in escrow until you're satisfied.",
  'paymentTimeline.tutor.phase1.phase': 'Day 1',
  'paymentTimeline.tutor.phase1.title': 'Parent Pays Platform',
  'paymentTimeline.tutor.phase1.description': 'Parent books lesson & makes payment (1-month upfront).',
  'paymentTimeline.tutor.phase1.detail1': 'Bank Transfer or TNG',
  'paymentTimeline.tutor.phase1.detail2': 'Secured in escrow',
  'paymentTimeline.tutor.phase2.phase': 'Week 1-4',
  'paymentTimeline.tutor.phase2.title': 'You Teach',
  'paymentTimeline.tutor.phase2.description': 'Conduct weekly lessons. Parent payments held in escrow for protection.',
  'paymentTimeline.tutor.phase2.detail1': 'Flexible schedule',
  'paymentTimeline.tutor.phase2.detail2': 'Track your hours',
  'paymentTimeline.tutor.phase2.detail3': 'Direct with parent',
  'paymentTimeline.tutor.phase3.phase': 'Month-end',
  'paymentTimeline.tutor.phase3.title': 'We Transfer to You',
  'paymentTimeline.tutor.phase3.description':
    'Your 75% (Month 1-2) or 100% (Month 3+) transferred to your bank account.',
  'paymentTimeline.tutor.phase3.detail1': 'Automatic transfer',
  'paymentTimeline.tutor.phase3.detail2': 'Your registered bank',
  'paymentTimeline.tutor.phase3.detail3': 'No delays',
  'paymentTimeline.parent.phase1.phase': 'Day 1',
  'paymentTimeline.parent.phase1.title': 'You Pay',
  'paymentTimeline.parent.phase1.description': 'Secure payment for 1 month of lessons. Choose payment method.',
  'paymentTimeline.parent.phase1.detail1': 'Bank Transfer or TNG',
  'paymentTimeline.parent.phase1.detail2': 'Encrypted & safe',
  'paymentTimeline.parent.phase1.detail3': '1 month upfront',
  'paymentTimeline.parent.phase2.phase': 'Payment to Escrow',
  'paymentTimeline.parent.phase2.title': 'Funds Protected',
  'paymentTimeline.parent.phase2.description':
    'Your payment held securely in escrow. Not released until lessons complete.',
  'paymentTimeline.parent.phase2.detail1': 'Zero risk policy',
  'paymentTimeline.parent.phase2.detail2': 'Easy refunds available',
  'paymentTimeline.parent.phase2.detail3': 'Your protection',
  'paymentTimeline.parent.phase3.phase': 'Week 1-4',
  'paymentTimeline.parent.phase3.title': 'Lessons Begin',
  'paymentTimeline.parent.phase3.description': 'Start weekly lessons with your tutor. Track progress directly.',
  'paymentTimeline.parent.phase3.detail1': 'Weekly schedule',
  'paymentTimeline.parent.phase3.detail2': 'Direct communication',
  'paymentTimeline.parent.phase3.detail3': 'No middleman',
  'paymentTimeline.parent.phase4.phase': 'Month-end',
  'paymentTimeline.parent.phase4.title': 'Tutor Gets Paid',
  'paymentTimeline.parent.phase4.description':
    "Funds released to tutor. You're notified. Plan next month or refund.",
  'paymentTimeline.parent.phase4.detail1': 'Transparent transfer',
  'paymentTimeline.parent.phase4.detail2': 'You have 7 days to dispute',
  'paymentTimeline.parent.phase4.detail3': 'Next month available',
};
